export default "__VITE_ASSET__Cz4F_fTK__"